import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCat,
  faCrow,
  faDog,
  faFish,
  faHorse,
  faMonkey,
  faPaw,
  faRabbit,
  faSheep,
  faSnake,
  faSpider,
  faTurtle,
} from '@fortawesome/pro-light-svg-icons';

import PetSpecies from '@/enums/PetSpecies';
import SpeciesTreatedType from '@/enums/SpeciesTreatedType';

library.add({
  faCat,
  faCrow,
  faDog,
  faFish,
  faHorse,
  faMonkey,
  faPaw,
  faRabbit,
  faSheep,
  faSnake,
  faSpider,
  faTurtle,
});

export default {
  methods: {
    petIcon(species) {
      return PetSpecies.getIcon(species);
    },
    speciesTreatedIcon(speciesTreatedType) {
      return SpeciesTreatedType.getIcon(speciesTreatedType);
    },
  },
};
